import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { addGroupRoleChildToModeling, removeGroupRoleChildFromModeling, expandGroupRole, setSelectedViewRole, selectModelingSystemId } from "../../../reducers/reports-modeling/roleLevelSlice";

import GroupRoleModelingBox from "../group-role-modeling-box";
import { integrationService } from "../../../services/integration-service";


const RoleLevelGroupRoleModelingBox = ({ selectedRole }) => {
    const dispatch = useDispatch();

    const [rows, setRows] = useState([]);
    const systemId = useSelector(selectModelingSystemId)
    const roles = useSelector((state) => state.reportsModeling.roleLevel.modeling.rolesForView);
    const isAddDisabled = !selectedRole?.isComplex;
    const isRoleExplicit = roles?.find(role => role.id === selectedRole?.id);
    const isRoleChild = !isRoleExplicit && !selectedRole?.isComplex;
    const isDeleteDisabled = !(isRoleExplicit || isRoleChild);

    const handleAddChildRole = (newChildRole) => {
        dispatch(
            addGroupRoleChildToModeling({
                parentId: selectedRole.id,
                childRole: newChildRole
            })
        );
        handleExpandChildrenRoles(selectedRole, true)
    }

    const handleRemoveChildRoles = () => {
        dispatch(
            removeGroupRoleChildFromModeling({
                roleIdToRemove: selectedRole.id
            }))
        dispatch(setSelectedViewRole(null))
    };

    const handleExpandChildrenRoles = (role, stayOpen = false) => {
        dispatch(setSelectedViewRole(role))
        dispatch(expandGroupRole({ role: role, stayOpen: stayOpen }))

    };

    const handleRowClick = (row, setActiveRow) => {
        dispatch(setSelectedViewRole(row))
        setActiveRow(row.id)
    }



    useEffect(() => {
        if (!roles) {
            return
        }

        const rows = []

        roles.forEach(role => {
            rows.push(role)
            if (role.isComplex && role.open) {
                role.children.forEach(childrenRole => {
                    rows.push(childrenRole)
                })
            }
        })

        setRows(rows)

    }, [roles])

    const getRoles = useCallback((params, signal) => {
        if (params && params["filters"]) {
            params["filters"].push({ field: "systemId", sign: "EQ", value: systemId });
        }

        return integrationService.getModelingRoles(params, signal);
    }, [systemId])

    return (
        <GroupRoleModelingBox
            roles={rows}
            selectedRole={selectedRole}
            onAddChildRole={handleAddChildRole}
            onRemoveChildRoles={handleRemoveChildRoles}
            handleRowClick={handleRowClick}
            handleExpandChildrenRoles={handleExpandChildrenRoles}
            isAddDisabled={isAddDisabled}
            isDeleteDisabled={isDeleteDisabled}
            getRoles={getRoles}
        />
    )
};

RoleLevelGroupRoleModelingBox.propTypes = {
    selectedRole: PropTypes.object
};

export default RoleLevelGroupRoleModelingBox